<div class="header">
  <div class="left-icons">
    <button (click)="onClose()" mat-icon-button aria-label="Back">
      <mat-icon title="Back">arrow_back</mat-icon>
    </button>
  </div>
  <div class="title">
    @if (headerItem?.id) {
      Bid item
    }
    @if (!headerItem?.id) {
      Add bid item
    }
  </div>
  <div class="right-icons">
    <button type="button" class="mat-inline-button" mat-button color="primary" (click)="saveAll()"
    [disabled]="!headerItem?._inputForm.controls['heading_id'].valid">Done</button>
  </div>
</div>

<div class="body">
  <div class="heading">
    <div class="mat-subtitle-1">{{biditem?.item}}</div>
    <div class="caption">{{biditem?.description}}</div>
  </div>

  @if (initialized && !byStation) {
    <ng-container [ngTemplateOutlet]="SingleForm" [ngTemplateOutletContext]="{ 'rbi': headerItem }">
    </ng-container>
  }

  @if (initialized && byStation) {
    <!-- Heading selector -->
    <section>
      <mat-form-field>
        <mat-label>Heading</mat-label>
        <mat-select (selectionChange)="onHeadingChange($event.value)" [(value)]="heading">
          @for (heading of headings; track heading) {
            <mat-option [value]="heading">{{heading.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </section>
    <!-- /Heading selector -->
    <!-- Station adder -->
    @if (heading) {
      <section>
        <div class="mat-body-2">Add Stations</div>
        <div class="row">
          <mat-form-field>
            <mat-label>From</mat-label>
            <input type="text" matInput [formControl]="fromStation"
              [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              @for (option of fromOptions | async; track option) {
                <mat-option [value]="option">
                  {{option.name}}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field>
            <mat-label>To</mat-label>
            <input type="text" matInput [formControl]="toStation"
              [matAutocomplete]="auto2">
            <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
              @for (option of toOptions | async; track option) {
                <mat-option [value]="option">
                  {{option.name}}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <div class="icons">
            <button mat-icon-button [disabled]="!(fromStation.value && toStation.value)"
              (click)="addStations()">
              <mat-icon title="Add">playlist_add</mat-icon>
            </button>
          </div>
        </div>
      </section>
    }
    <!-- /Station adder -->
    @if (rollupField) {
      <section>
        <div class="mat-body-2">Quantity</div>
        <mat-form-field>
          @if (rollupField?.uom || biditem?.uom) {
            <span class="mat-body-2" matSuffix>
              @if (rollupField?.uom) {
                (S{{rollupField?.uom}})
              }
              @if (!rollupField?.uom && biditem?.uom) {
                ({{biditem?.uom}})
              }
            </span>
          }
          <input matInput type="number" autocomplete="off" [disabled]="true" [value]="headerItem?.quantity | number:'1.0-' + (biditem?.quantity_rounding ?? 2)" />
        </mat-form-field>
      </section>
    }
    <!-- Station Forms -->
    @if (lineItems.length) {
      <mat-accordion class="line-items">
        @for (li of lineItems; track li) {
          <mat-expansion-panel [expanded]="li._id === selectedItem?._id">
            <mat-expansion-panel-header (click)="selectLineItem(li)">
              <div class="header-row">
                <span>
                  @if ((!li._inputForm.valid && !li._inputForm.pristine)) {
                    <mat-icon color="warn">error</mat-icon>
                  }
                  <ng-container>{{li?.station?.name}}</ng-container>
                  @if (li?.station_break) {
                    <mat-icon>emoji_flags</mat-icon>
                  }
                  @if (li?.start_of_work) {
                    <mat-icon>start</mat-icon>
                  }
                </span>
                <div class="icons">
                  <!-- More menu -->
                  <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    @if (rollupField) {
                      <button mat-menu-item (click)="toggleFlag(li, 'station_break')">
                        <mat-icon>emoji_flags</mat-icon>
                        <span>
                          @if (li?.station_break) {
                            Remove station break
                          }
                          @if (!li?.station_break) {
                            Add station break
                          }
                        </span>
                      </button>
                    }
                    @if (heading?.is_circular) {
                      <button mat-menu-item (click)="toggleFlag(li, 'start_of_work')">
                        <mat-icon>start</mat-icon>
                        <span>
                          @if (li?.start_of_work) {
                            Remove start of work
                          }
                          @if (!li?.start_of_work) {
                            Add start of work
                          }
                        </span>
                      </button>
                    }
                    <button mat-menu-item (click)="delete(li)">
                      <mat-icon>delete</mat-icon>
                      <span>Remove station</span>
                    </button>
                  </mat-menu>
                  <!-- /More menu -->
                </div>
              </div>
            </mat-expansion-panel-header>
            <ng-container [ngTemplateOutlet]="SingleForm" [ngTemplateOutletContext]="{'rbi': li}">
            </ng-container>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
    <!-- /Station Forms -->
    <!-- Delete all items -->
    <section>
      <br />
      <button type="button" class="mat-inline-button" mat-button color="primary" (click)="deleteAll()">
        <mat-icon>delete</mat-icon> Delete bid item
      </button>
    </section>
    <!-- /Delete all items -->
    <ng-container [ngTemplateOutlet]="readOnlyToolbarItems"
    [ngTemplateOutletContext]="{'rbi': headerItem}"></ng-container>
  }
</div>

@if (initialized) {
  <div class="footer">
    @if (selectedItem) {
      <app-report-item-toolbar [lineItem]="selectedItem" [project]="project"
      (changed)="onLineItemChange($event)"></app-report-item-toolbar>
    }
  </div>
}

<ng-template #SingleForm let-rbi="rbi" let-i="i">
  <form [formGroup]="rbi._inputForm">
    <section style="display: none;">
      <input matInput type="text" formControlName="id" />
      <input matInput type="text" formControlName="bid_item_id" />
    </section>

    @if (!rollupField) {
      <section>
        <div class="width-50">
          <div class="mat-body-2">Quantity</div>
          @if (biditem['rollup']) {
            <div
              class="rollup-allowed"
              >
              @if (biditem.rollup_quantity_editable) {
                <div
                  class="rollup-editable"
                  >
                  @if (biditem['rollup']) {
                    <mat-form-field
                      >
                      <mat-select
                        formControlName="isManual"
                        >
                        <mat-option [value]="false">Auto Calculate</mat-option>
                        <mat-option [value]="true">Enter Manually</mat-option>
                      </mat-select>
                    </mat-form-field>
                  }
                  <mat-form-field>
                    @if (biditem?.uom) {
                      <span class="mat-body-2" matSuffix>({{biditem?.uom}})</span>
                    }
                    <input
                      matInput
                      type="text"
                      onlyDigits
                      [decimalPlaces]="biditem?.quantity_rounding ?? 2"
                      autocomplete="off"
                      formControlName="quantity"
                      [errorStateMatcher]="matcher"
                      />
                    @if (rbi._inputForm.controls.quantity.hasError('required')) {
                      <mat-error>
                        This field is required
                      </mat-error>
                    }
                    @if (rbi._inputForm.controls.quantity.hasError('error')) {
                      <mat-error>
                        {{rbi._inputForm.controls.quantity.errors?.error}}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              } @else {
                <div class="quantity-not-editable">
                  {{ rbi._inputForm.controls.quantity.value | number:'1.0-' + (biditem?.quantity_rounding ?? 2) }}
                </div>
              }
            </div>
          } @else {
            <mat-form-field>
              @if (biditem?.uom) {
                <span class="mat-body-2" matSuffix>({{biditem?.uom}})</span>
              }
              <input
                matInput
                type="text"
                onlyDigits
                [decimalPlaces]="biditem?.quantity_rounding ?? 2"
                autocomplete="off"
                formControlName="quantity"
                [errorStateMatcher]="matcher"
                />
              @if (rbi._inputForm.controls.quantity.hasError('required')) {
                <mat-error>
                  This field is required
                </mat-error>
              }
              @if (rbi._inputForm.controls.quantity.hasError('error')) {
                <mat-error>
                  {{rbi._inputForm.controls.quantity.errors?.error}}
                </mat-error>
              }
            </mat-form-field>
          }
        </div>
      </section>
    }

    <section class="custom-fields">
      @for (field of fields; track field) {
        <app-field-input
                       [notifyOnChange]="field?.id === rollupField?.id ||
                       biditem['rollup']"
          (onValueChange)="updateRollup()" [station]="rbi.station" [field]="field"
          [recentValueQry]="recentValueQry"
        [form]="rbi._inputForm" [matcher]="matcher" [class]="getWidth(field)"></app-field-input>
      }
    </section>
    <div style="clear: both"></div>

    @if (!byStation) {
      <section>
        <br />
        <button type="button" class="mat-inline-button" mat-button color="primary" (click)="delete(rbi)">
          <mat-icon>delete</mat-icon> Delete bid item
        </button>
      </section>
    }
  </form>
  <ng-container [ngTemplateOutlet]="readOnlyToolbarItems" [ngTemplateOutletContext]="{'rbi': rbi}"></ng-container>

</ng-template>

<ng-template #readOnlyToolbarItems let-rbi="rbi">
  @if (rbi.pictures.length) {
    <section>
      <div style="margin-top: 20px" class="mat-body-2">Pictures</div>
      <div class="preview-list">
        @for (pic of rbi.pictures; track pic) {
          <div>
            <img [src]="pic.getThumbnail()" class="link" (click)="appSrv.openCarousel($event, rbi.pictures, pic)" />
          </div>
        }
      </div>
    </section>
  }

  @if (rbi.annotations.length) {
    <section>
      <div class="mat-body-2">Annotations</div>
      <div class="preview-list">
        @for (ann of rbi.annotations; track ann) {
          <div>
            <img [src]="ann.getThumbnail()" class="link" />
          </div>
        }
      </div>
    </section>
  }

  @if (!rbi.location.isEmpty) {
    <section>
      <div class="mat-body-2">Location</div>
      <div>
        <app-location-picker [isDialog]="false" [latitude]="rbi.location.lat" [longitude]="rbi.location.lng"
        height="100px" [readOnly]="true"></app-location-picker>
      </div>
    </section>
  }

  @if (rbi.comment) {
    <section>
      <div class="mat-body-2">Comment</div>
      <mat-form-field appearance="outline">
        <textarea matInput rows="5" [value]="rbi.comment" [disabled]="true"></textarea>
      </mat-form-field>
    </section>
  }
</ng-template>
